import { White } from "@traceair/tds";
import React, { memo } from "react";
import type { IconProps } from "./_IconProps";

const Ok = ({ color = White }: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1771_823)">
        <rect width="24" height="24" rx="8" fill={color} />
        <path
          d="M15.6799 10L15.1487 10.5312L10.8995 14.7804L8.89982 12.7808L8.3999 12.2809"
          stroke="#00A546"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1771_823">
          <rect width="24" height="24" rx="8" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(Ok);
